import { render } from "./msgItem.vue?vue&type=template&id=65e33a85&scoped=true"
import script from "./msgItem.vue?vue&type=script&lang=js"
export * from "./msgItem.vue?vue&type=script&lang=js"

import "./msgItem.vue?vue&type=style&index=0&id=65e33a85&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e33a85"]])

export default __exports__